var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "pagination-menu"
  }, [_c('a', {
    staticClass: "navlink prev",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('a', {
    staticClass: "navlink active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("…")]), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('a', {
    staticClass: "navlink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('a', {
    staticClass: "next navlink",
    attrs: {
      "href": "#"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404cfbd2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/pagination-menu/pagination-menu.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-404cfbd2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/pagination-menu/pagination-menu.vue
// module chunks = index